import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import type { FormValues } from '../types.ts';

import { useLocalStorage } from '#src/hooks/storage.ts';

export const SaveFormValues = ({ children }: { children: React.ReactNode }) => {
  const { watch } = useFormContext<FormValues>();
  const [, setLocalFormValues] = useLocalStorage<FormValues | null>(
    '/seek-developer/contact-form',
    null,
  );
  useEffect(() => {
    const { unsubscribe } = watch((value) => {
      setLocalFormValues(value as FormValues);
    });
    return () => unsubscribe();
  }, [watch, setLocalFormValues]);

  return children;
};
